<div>
  <img class="header-image" [src]="producePath" alt="produce" />
  <div class="content-wrapper">
    <div class="left-content">
      <div>
        <h2 class="rate-header-style">Current Rates</h2>
        <p class="rate-text-style">
          Explore available rates by origin or destination
        </p>
        @if(originTransloadChips.length > 0 || destinationTransloadChips.length
        > 0){
        <div class="current-rates">
          <!-- Origin Transload -->
          @if (originTransloadChips.length > 0) {
          <ng-container>
            <h6>Origin Transload</h6>
            <br />
            @for (k of [render.origin]; track k) {
            <app-chip-filter
              class="chip-section"
              [chips]="originTransloadChips"
              [selected]="
                selected?.moveType === 'ORIGIN' ? selected?.id ?? '' : ''
              "
              (selectedChip)="onSelectOrigin($event)"
            ></app-chip-filter>
            }
            <br />
          </ng-container>
          }
          <!-- Destination Transload -->
          @if (destinationTransloadChips.length > 0) {
          <ng-container>
            <h6>Destination Transload</h6>
            <br />
            @for (k of [render.destination]; track k) {
            <app-chip-filter
              class="chip-section"
              [chips]="destinationTransloadChips"
              [selected]="
                selected?.moveType === 'DESTINATION' ? selected?.id ?? '' : ''
              "
              (selectedChip)="onSelectDestination($event)"
            />
            }
            <br />
          </ng-container>
          }
        </div>
        }
      </div>
    </div>
    <!-- Right side content -->
    <div class="right-content">
      <app-custom-rate></app-custom-rate>
      @if(salesManagerDetails){
      <app-representative-details
        [salesManagerDetails]="salesManagerDetails"
      ></app-representative-details>
      }
    </div>
  </div>
  <!-- full content -->
  <div class="full-screen">
    @if(selected?.id){
    <div class="search-table-container">
      <app-public-review
        #publicReviewProd
        [currentId]="selected.id"
        [publicProgramData]="publicProgramData"
      ></app-public-review>
    </div>
    } @else {
    <div>
      <app-no-results></app-no-results>
    </div>
    }
  </div>
</div>
